export default __webpack_public_path__ + "img/perfil.c1f7c25a.svg";